import React, { useEffect, useState } from "react";
import secureAxios from "../../utils/secureAxios";
import TicketComments from "./TicketComments";
import { useAuth } from "../../contexts/AuthContext";
import { getApiBaseURL } from "../../utils/api";
import { Link, useNavigate } from "react-router-dom";

const TicketList = () => {
  const { user } = useAuth();
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [statusFilter, setStatusFilter] = useState("open"); // hide closed by default
  const navigate = useNavigate();
  const apiBase = getApiBaseURL();

  // const apiBase = process.env.REACT_APP_API_BASE || "";

  const loadTickets = async () => {
    try {
      const response = await secureAxios.get(`${apiBase}/api/tickets`, {
        params: {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          is_primary: user.is_primary,
          is_platform_admin:
            user.is_admin && user.is_primary ? "true" : "false",
        },
      });
      setTickets(response.data);
    } catch (err) {
      console.error("Error loading tickets:", err);
    }
  };

  useEffect(() => {
    loadTickets();
  }, [user.user_id, user.tenant_id, user.is_primary, user.is_admin]);

  const filteredTickets = tickets.filter((ticket) => {
    return statusFilter === "all" || ticket.status.toLowerCase() !== "closed";
  });

  if (!user) return <div>Loading...</div>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Tickets</h5>
        <div className="d-flex gap-2">
          <select
            className="form-select w-auto"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="open">Hide Closed</option>
            <option value="all">Show All</option>
          </select>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => navigate("/crm/dashboard")}
          >
            Return to Dashboard
          </button>
        </div>
      </div>

      <ul className="list-group mb-4">
        {filteredTickets.map((ticket) => (
          <li
            className="list-group-item d-flex justify-content-between align-items-start flex-column flex-md-row"
            key={ticket.ticket_id}
          >
            <div className="mb-2 mb-md-0">
              <strong>{ticket.subject}</strong> ({ticket.status}) – Priority:{" "}
              {ticket.priority}
              <br />
              <span className="text-muted small">
                Created by {ticket.created_by} | Tenant: {ticket.tenant_name}
              </span>
              {ticket.assigned_to_name && (
                <span className="ms-2 text-muted">
                  – Assigned to {ticket.assigned_to_name}
                </span>
              )}
            </div>

            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => setSelectedTicket(ticket)}
              >
                View / Comment
              </button>
              {user.is_admin && user.is_primary && (
                <Link
                  to={`/crm/tickets/${ticket.ticket_id}/edit`}
                  className="btn btn-sm btn-outline-warning"
                >
                  Edit
                </Link>
              )}
            </div>
          </li>
        ))}
      </ul>

      {selectedTicket && (
        <TicketComments
          ticket={selectedTicket}
          onClose={() => setSelectedTicket(null)}
        />
      )}
    </div>
  );
};

export default TicketList;
